import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {appInjector} from "../../appInjector";
import {ItemEvent} from "../../ItemEvent";
import {ToolsService} from "../../../services/toolsService/tools.service";
import {CesiumAdapterService} from "../../../services/cesiumAdapter21/cesium-adapter.service";
import {BabyNumber} from "./BabyNumber";
import {BabyNumberComponent} from "./baby-number/baby-number.component";
import {MapObjectPlugin} from "../MapObjectPlugin";
import {MapPosition} from "../../../models/MapPosition";
import {ItemConfig} from "../../../models/ItemConfig";
import {BabyAdapterService} from "./babyAdapter/baby-adapter.service";
import {LabelStyleProviderService} from "../../../services/labelStylesProvider/label-style-provider.service";
import {BabyNumberComponent21} from "../../../components_2.1/baby-number/baby-number.component";
import {debounceTime, skipWhile} from "rxjs/operators";
import {ConcreteLayerService} from "../../../services/concreteLayer/concrete-layer.service";


export class BabyNumbersPlugin extends AbstractMainPlugin {

  private toolProvider;
  private cs:ConcreteLayerService;
  private readonly view;
  private babyAdapter;
  public mapOverlay;
  public styleProvider;
  private currentHash;
  private isInitialized = false;
  private hasItemId = true;
  private currentAnchorPos;
  private isCameraMoving = false;
  private isLabelDisabled = false;
  private isLabelGlobalDisabled = false;

  private babyCo = null;
  // private currentTool;

  static getBeforeItemComponents() {
    // return [];
    return window['isNewDesign21'] ? [BabyNumberComponent21] : [BabyNumberComponent];
  }

  constructor(item:Item) {
    super(item);
    this.toolProvider = appInjector.get(ToolsService);
    this.cs = appInjector.get(ConcreteLayerService);
    this.view = appInjector.get(CesiumAdapterService);
    this.currentHash = JSON.stringify(this.item.config.getInputByName('__baby_number'));
    this.babyAdapter = appInjector.get(BabyAdapterService);
    this.styleProvider = appInjector.get(LabelStyleProviderService);

    // this.init(item);
    this.initListeners();

    this.anchorSubjectHandler();
  }


  private onConfigUpdated(newConfig:ItemConfig){
    let newHash = JSON.stringify(newConfig.getInputByName('__baby_number'));

    if (newHash.toString() == this.currentHash.toString() || !newConfig.getInputByName('__baby_number') || !this.mapOverlay){
      return;
    }

    let currentInput = JSON.parse(this.currentHash);


    if (!currentInput || (newConfig.getInputProp('__baby_number', 'value') != currentInput.value)){
      this.mapOverlay.setBabyNumber(newConfig.getInputProp('__baby_number', 'value') || null);
      this.mapOverlay.changeBabyAnchor(newConfig.getInputProp('__baby_number', 'anchor') || null)
    }

    if (currentInput && newConfig.getInputProp('__baby_number', 'anchor') != currentInput.anchor && currentInput.value && currentInput.value.length>0){
      this.mapOverlay.changeBabyAnchor(newConfig.getInputProp('__baby_number', 'anchor') || null)
    }
    //
    //
    if (newConfig.getInputProp('__baby_number', 'style') && newConfig.getInputProp('__baby_number', 'value') && newConfig.getInputProp('__baby_number', 'value').length>0){
      const styleName = newConfig.getInputProp('__baby_number', 'style');
      this.mapOverlay.setStyle(styleName);
      this.styleProvider.getZoomStyleByKey(styleName).subscribe((preparedStyles)=>{
        this.mapOverlay.setOverlayStyles(preparedStyles || null);
      })
    }
    let input = this.item.config.getInputByName('__baby_number');
    this.babyAdapter.addToBabyCollection(this.item.getId(), {overlay: this.mapOverlay, style: input.style, anchor: input.anchor});

    this.currentHash = newHash;
  }

  private generateBabyId(id) {
    return `baby-id-${id}`
  }

  private async anchorSubjectHandler(){
    let anchorPosition = this.currentAnchorPos;
    //anchor position - right position of item

    if (!this.item.getId()){
      this.hasItemId = false;
      return;
    }
    if (!this.hasItemId){
      return;
    }
    if (this.isInitialized){
      this.mapOverlay.overlayChangePosition(anchorPosition);
      return;
    }

    if (this.item.config.getTool() && this.item.config.getTool().has_baby_number){
      let input = this.item.config.getInputByName('__baby_number');
      if (!input){
        this.item.config.createInputValue('__baby_number', {
          anchor: "CENTER",
          mapLabelCSSStyle: "",
          mapLabelMargins: [0, 0],
          mapLabelPosition: {},
          showOnMap: true,
          style: "",
          value: "",
        });
        input = this.item.config.getInputByName('__baby_number');
      }

      this.mapOverlay = new BabyNumber(this.view, this.generateBabyId(this.item.getId()), anchorPosition, input);

      let defaultName = 'Black large';

      if (!input.style || input.style.trim().length == 0){
        let list = await this.styleProvider.getAll()
        let styleName = list.hasOwnProperty(defaultName) ? defaultName: Object.keys(list)[0];
        this.item.config.setInputValue('__baby_number', 'style', styleName);
        this.mapOverlay.setStyle(styleName);

        this.styleProvider.getZoomStyleByKey(input.style).subscribe((preparedStyles)=>{
          this.mapOverlay.setOverlayStyles(preparedStyles || null)
        })
      }
      else{
        this.styleProvider.getZoomStyleByKey(input.style).subscribe((preparedStyles)=>{
          this.mapOverlay.setOverlayStyles(preparedStyles || null)
        },(error) => {console.error(error)})
      }

      this.babyAdapter.addToBabyCollection(this.item.getId(), {overlay: this.mapOverlay, style: input.style, anchor: input.anchor});
      this.isInitialized = true;
    }
  }

  initListeners() {
    this.item.getSubject(Item.LABEL_VISIBILITY).subscribe((flag)=>{
      this.isLabelGlobalDisabled = !flag;
      if (this.mapOverlay &&  this.item.config.getInputProp('__baby_number', 'value').trim().length > 0){

        if (this.isLabelGlobalDisabled){
          return this.mapOverlay.setLabelDisabledValue(this.isLabelGlobalDisabled);
        }

        if (this.item.config.getConcreteLayerId() == this.cs.currentVisibleConcreteLayer.id){
          if (this.item.getSubjectValue(Item.SUBJECT_VISIBILITY)){
            this.isLabelDisabled = false;
          }
          this.mapOverlay.setLabelDisabledValue(this.isLabelDisabled);
        }
      }
    });
    this.item.getSubject(Item.SUBJECT_VISIBILITY).subscribe((flag)=>{
      this.isLabelDisabled = !flag;
      if (this.isLabelGlobalDisabled){
        this.isLabelDisabled = this.isLabelGlobalDisabled;
      }
      if (this.mapOverlay &&  this.item.config.getInputProp('__baby_number', 'value').trim().length > 0){
        this.mapOverlay.setLabelDisabledValue(this.isLabelDisabled);
      }
    });

    this.item.getSubject(MapObjectPlugin.ANCHOR_SUBJECT).subscribe((anchorPosition:MapPosition|MapPosition[]) => {
      this.currentAnchorPos = anchorPosition;
      this.anchorSubjectHandler();
    });

    this.item.getSubject(Item.BABY_SUBJECT).subscribe((elm:{overlay:BabyNumber, style, anchor, css})=>{
      elm.overlay.setStyle(elm.style);
      this.item.config.assignInput('__baby_number', {style: elm.style, anchor: elm.anchor});
    });

    this.view.cameraEventMoveStart.subscribe(() => { this.isCameraMoving = true; });
    this.view.cameraEventMoveEnd.subscribe(() => { this.isCameraMoving = false; });

    this.item.config.subject.subscribe((newConfig)=>{
      if (!this.hasItemId){
        this.hasItemId = (newConfig.getId());
        this.anchorSubjectHandler();
      }
     this.onConfigUpdated(newConfig);
    });

    this.item.config.serverUpdate.subscribe((newConfig)=>{
      this.onConfigUpdated(newConfig);
    });

    this.item.emitter.subscribe((event: ItemEvent)=>{
      if (event.getEventName() == 'removeObject' && this.mapOverlay){
          this.mapOverlay.removeBabyNumber();
      }
    });

    // (config)=> interval(500),{trailing: true}
    this.view.zoom
      .pipe(
        debounceTime(500)
      )
      .pipe(
        skipWhile(() => this.isCameraMoving == true)
    )
      .subscribe((status)=>{
      if (this.isCameraMoving){
        return;
      }
      if (!this.item.config.getInputProp('__baby_number', 'value') || this.item.config.getInputProp('__baby_number', 'value').length == 0){
        if (this.mapOverlay){
          this.mapOverlay.hideBabyNumber();
        }
        return;
      }
      if (!this.mapOverlay){
        return;
      }

      let styleName = this.item.config.getInputByName('__baby_number').style || null;
      if (!styleName){
        this.babyAdapter.stylesList.subscribe((list)=>{
          if (!list){
            return;
          }
          styleName = Object.keys(list)[0];
          this.styleProvider.getZoomStyleByKey(styleName).subscribe((preparedStyles)=>{
            this.mapOverlay.setStyle(styleName);
            this.mapOverlay.showBabyNumber();
            this.mapOverlay.setOverlayStyles(preparedStyles || null)
          }, (error) => {console.error(error)})
        });
        return;
      }

      this.styleProvider.getZoomStyleByKey(styleName).subscribe((preparedStyles)=>{
        this.mapOverlay.setStyle(styleName);
        this.mapOverlay.showBabyNumber();
        this.mapOverlay.setOverlayStyles(preparedStyles || null)
      },(error) => {console.error(error)})

    });
  }



}
